import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DemandeRecuperationAbsencesFuturesDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeRecuperationAbsencesFuturesDto";
import { DemandeTransfertAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeTransfertAbsenceDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { SalarieContratDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import ModalAbsencesFuturesFinDeContrat from "../../modalComponents/modalAbsencesFuturesFinDeContrat/modalAbsencesFuturesFinDeContrat";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import ModalTransfertAbsencesFutures from "../../modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures";

interface salarieChargeInfos {
    errorMessage: string[];
    isModified: boolean;
    salarieCourant?: SalarieContratDto;
    proprietePrincipalesChanged: boolean

    // Qualification
    dateEntree?: string;
    dateDebut?: string;
    dateFinPrevisionnelle?: string;
    dateFinContrat?: string;
    dateDepartSalarie?: string;
    dateFinPeriodeEssai?: string;
    dureeContrat?: number;
    qualificationOrigine: ParametreDto | undefined;
    classificationOrigine: ParametreDto | undefined;

    // Départ
    dateNotificationRupture?: string;
    dateSignatureRuptConv?: string;
    dateEntretienPrealable?: string;
    dateDernierJourTravailleEtPaye?: string;
    dateDebutPreavis?: string;
    dateFinPreavis?: string;
}

@Component({
    components: {
        ListeRubriquesSalarieComponent: require("../listeRubriques/listeRubriquesSalarie.vue.html"),
        ModalAbsencesFuturesFinDeContrat: require("../../modalComponents/modalAbsencesFuturesFinDeContrat/modalAbsencesFuturesFinDeContrat.vue.html"),
        ModalTransfertAbsencesFutures: require("../../modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures.vue.html")
    }
})
export default class QualificationSalarieComponent extends Vue {
    public canModify = false;
    public currentId = 0;
    public dataReady = false;
    public isModified = false;
    public errorMessage: string[] = [];
    public salarieCharges: salarieChargeInfos[] = [];
    public salarieCourant?: SalarieContratDto;
    public proprietePrincipalesChanged = false;
    public listeConventionCollectives: ParametreDto[] = [];
    public listeQualificationsSalarie: ParametreDto[] = [];

    // Liste de toutes les qualifications.
    public listeQualifications: ParametreDto[] = [];
    // Liste des qualifications proposées filtrées sur la convention et l'archivage.
    public listeQualificationsFiltrees: ParametreDto[] = [];
    // Liste de toutes les classifications.
    public listeClassifications: ParametreDto[] = [];
    // Liste des classifications filtrées sur l'arichage.
    public listeClassificationsFiltrees: ParametreDto[] = [];
    // La qualification du salarié au chargement
    public qualificationOrigine: ParametreDto | undefined;
    // La classification du salarié au chargement
    public classificationOrigine: ParametreDto | undefined;

    public listeCodeInsees: ParametreDto[] = [];
    public listeDureeContrats: ParametreDto[] = [];
    public listeMotifDebuts: ParametreDto[] = [];
    public listeMotifDeparts: ParametreDto[] = [];
    public listeMotifsDepartFiltree: ParametreDto[] = [];
    public listeMotifRuptures: ParametreDto[] = [];
    public listTypesPreavis: ParametreDto[] = [];

    /** ici les dates **/
    // Qualification
    public dateEntree?: string = undefined;
    public dateDebut?: string = undefined;
    public dateFinPrevisionnelle?: string = undefined;
    public dateFinContrat?: string = undefined;
    public dateDepartSalarie?: string = undefined;
    public dateFinPeriodeEssai?: string = undefined;
    // Départ
    public dateNotificationRupture?: string = undefined;
    public dateSignatureRuptConv?: string = undefined;
    public dateEntretienPrealable?: string = undefined;
    public dateDernierJourTravailleEtPaye?: string = undefined;
    public dateDebutPreavis?: string = undefined;
    public dateFinPreavis?: string = undefined;

    public isInitialized = false;
    public dureeContrat?: number = undefined;
    public isDateNotifRuptureEnabled = true;
    public isDateSignatureRuptConv = true;
    public peutModifierDatesContrat = false;
    public showNbForfaitJours = ["C01", "C02", "C03", "C04"];
    public nbForfaitJoursParDefaut = 218;
    public isDateNotificationRuptureRequired = false;

    public modalAbsencesFuturesFinDeContrat?: ModalAbsencesFuturesFinDeContrat;
    public modalTransfertAbsencesFutures?: ModalTransfertAbsencesFutures;

    public reloadData(id: number): void {
        if (this.currentId > 0) {
            this.salarieCharges[this.currentId] = {
                // Qualification
                dateEntree: this.dateEntree,
                dateDebut: this.dateDebut,
                dateFinPrevisionnelle: this.dateFinPrevisionnelle,
                dateFinContrat: this.dateFinContrat,
                dateDepartSalarie: this.dateDepartSalarie,
                dateFinPeriodeEssai: this.dateFinPeriodeEssai,
                dureeContrat: this.dureeContrat,
                qualificationOrigine: this.qualificationOrigine,
                classificationOrigine: this.classificationOrigine,
                // Départ
                dateNotificationRupture: this.dateNotificationRupture,
                proprietePrincipalesChanged: this.proprietePrincipalesChanged,
                dateSignatureRuptConv: this.dateSignatureRuptConv,
                dateEntretienPrealable: this.dateEntretienPrealable,
                dateDernierJourTravailleEtPaye: this.dateDernierJourTravailleEtPaye,
                dateDebutPreavis: this.dateDebutPreavis,
                dateFinPreavis: this.dateFinPreavis,

                errorMessage: this.errorMessage,
                isModified: this.isModified,
                salarieCourant: this.salarieCourant
            };
        }
        this.setListeMotifsDepartFiltree();

        this.currentId = id;
        this.fetchData();
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getConventionsCollectives(data => {
            this.listeConventionCollectives = data;
        });
        ServicesFactoryInstance.ParametresService.getQualifications(true, data => {
            this.listeQualifications = data;
        });
        ServicesFactoryInstance.ParametresService.getClassifications(true, data => {
            this.listeClassifications = data;
        });
        ServicesFactoryInstance.ParametresService.getQualificationsSalarie(data => {
            this.listeQualificationsSalarie = data;
        });
        ServicesFactoryInstance.ParametresService.getCodeInsees(data => {
            this.listeCodeInsees = data;
        });
        ServicesFactoryInstance.ParametresService.getDureeContrats(data => {
            this.listeDureeContrats = data;
        });
        ServicesFactoryInstance.ParametresService.getMotifDeparts(true, data => {
            this.listeMotifDeparts = data;
            this.setListeMotifsDepartFiltree();
        });
        ServicesFactoryInstance.ParametresService.getMotifDebuts(data => {
            this.listeMotifDebuts = data;
        });
        ServicesFactoryInstance.ParametresService.getMotifRuptures(data => {
            this.listeMotifRuptures = data;
        });
        ServicesFactoryInstance.ParametresService.getTypesPreavis(data => {
            this.listTypesPreavis = data;
        });
    }

    public init(): void {
        if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined) {
            return;
        }
        this.initConstantes();
        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
        this.peutModifierDatesContrat = !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);

        this.isInitialized = true;
    }

    public mounted(): void {
        this.isInitialized = false;

        // On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)

        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            this.init();
        });
        this.init();
    }

    public refreshQualification(): void {
        this.fetchData();
    }

    public refreshAbsences(): void {
        this.$emit("refreshAbsences");
    }

    public setDureeContrat(): void {
        const dateDebut = moment(this.dateDebut);
        const dateFin = moment(this.dateFinPrevisionnelle);
        if (dateDebut != undefined && dateFin != undefined && dateFin >= dateDebut) {
            const moisDebut = (dateDebut.year() * 12) + dateDebut.month();
            const moisFin = (dateFin.year() * 12) + dateFin.month() + 1;
            this.dureeContrat = moisFin - moisDebut;
        } else {
            this.dureeContrat = undefined;
        }
    }

    public resetData(id: number): void {
        if (this.salarieCharges[id] != undefined) {
            this.salarieCharges[id].isModified = false;
        }
        if (this.currentId == id) {
            this.fetchData();
        }
    }

    public setListeQualificationsFiltrees(): void {
        if (this.salarieCourant && this.listeQualifications) {
            const code = this.salarieCourant.CodeConventionCollective;
            // On affiche les qualifications non archivées liées à la convention chargée.
            // Si la qualification initialement paramétrée dans le contrat est archivée, elle est aussi contenue à la liste.
            this.listeQualificationsFiltrees = this.listeQualifications.filter(q => q.LibelleCourt == code && (!q.EstArchive || (this.qualificationOrigine && q.Code === this.qualificationOrigine.Code)));
        } else {
            this.listeQualificationsFiltrees = [];
        }
    }

    public setListeClassificationsFiltrees(): void {
        if (this.listeClassifications) {
            // On affiche les classifications non archivées. Si la classification initialement paramétrée dans le contrat est archivée, elle est aussi contenue dans la liste.
            this.listeClassificationsFiltrees = this.listeClassifications.filter(c => !c.EstArchive || !this.classificationOrigine || c.Code === this.classificationOrigine.Code);
        } else {
            this.listeClassificationsFiltrees = [];
        }
    }

    public setListeMotifsDepartFiltree(): void {
        if (this.salarieCourant?.CodeMotifDepart != undefined) {
            this.listeMotifsDepartFiltree = this.listeMotifDeparts.filter(m => !m.EstArchive || m.Code == this.salarieCourant?.CodeMotifDepart);
        } else {
            this.listeMotifsDepartFiltree = this.listeMotifDeparts.filter(m => !m.EstArchive);
        }
    }

    public modifyPropertiesPrincipales(): void {
        this.proprietePrincipalesChanged = true && this.salarieCourant != undefined && this.salarieCourant.ContratActif;
        this.modifyForRubriques();
    }

    public modifyConvention(): void {
        this.setListeQualificationsFiltrees();
        this.modifyPropertiesPrincipales();
    }

    public modifyLibelleEmploi(): void {
        this.modify();
        const libelleChoisi = this.listeQualificationsSalarie.filter(q => this.salarieCourant != null && q.Libelle == this.salarieCourant.LibelleEmploi)[0];
        if (this.salarieCourant != null && libelleChoisi && libelleChoisi.LibelleCourt) {
            this.salarieCourant.CodeCodeInsee = libelleChoisi.LibelleCourt;
        }
    }

    public modifyCodeClassification(): void {
        this.modifyPropertiesPrincipales();
        this.updateClassification();
    }

    public updateClassification(): void {
        if (this.salarieCourant != undefined) {
            const code = this.salarieCourant.CodeQualification;
            this.salarieCourant.CodeClassification = code;
            if (code != undefined) {
                const classif = this.listeClassificationsFiltrees.filter(c => c.Code == code)[0];
                if (classif != undefined && (this.salarieCourant.LibelleEmploi == undefined || this.salarieCourant.LibelleEmploi == "")) {
                    this.salarieCourant.LibelleEmploi = classif.Libelle;
                }
            }
        }
        this.modifyForRubriques();
    }

    public modifyForRubriques(): void {
        this.modify();
        this.$children.forEach(c => {
            const child: any = c;
            if (child.refreshRubriquesVisibleContrat != undefined) {
                child.refreshRubriquesVisibleContrat();
            }
        });
    }

    public modifyMotifDeparts(): void {
        if (this.salarieCourant) {
            const code = this.salarieCourant.CodeMotifDepart;
            if (code == "008") {
                this.salarieCourant.CodeMotifRuptureContrat = "31";
            } else if (code == "134") {
                this.salarieCourant.CodeMotifRuptureContrat = "39";
            } else if (code == "902") {
                this.salarieCourant.CodeMotifRuptureContrat = "998";
            } else {
                const motif = this.listeMotifsDepartFiltree.filter(m => m.Code == code)[0];
                if (motif) {
                    const libelle = motif.Libelle;
                    const motifRupture = this.listeMotifRuptures.filter(m => m.Libelle == libelle)[0];

                    if (motifRupture) {
                        this.salarieCourant.CodeMotifRuptureContrat = motifRupture.Code;
                    }
                }
            }
        }
        this.modify();
    }

    public modifyDateDepartSalarie(): void {
        if (moment.utc(this.dateDepartSalarie).isValid()) {
            this.dateFinContrat = this.dateDepartSalarie;
        }
        this.modify();
    }

    public modifyDateFinPrevisionnelle(): void {
        this.setDureeContrat();
        this.modifyDureeContrat();
    }

    public modifyDateDebut(): void {
        this.setDureeContrat();
        this.modifyDureeContrat();
        this.modifyInfoCsg();
        this.modifyForRubriques();
    }

    public modifyInfoCsg() {
        this.$children.forEach(c => {
            const child: any = c;
            if (child.setInfoCsg != undefined) {
                child.setInfoCsg(this.dateDebut);
            }
        });
    }

    public modifyDateEntree(): void {
        this.proprietePrincipalesChanged = true && this.salarieCourant != undefined && this.salarieCourant.ContratActif;

        this.dateDebut = this.dateEntree;
        this.modifyDateDebut();
    }

    public onDateFinContratChange(): void {
        if (this.salarieCourant && !this.departIsSet()) {
            // La date de fin de contrat ne respecte pas les conditions du bloc Départ, on purge les données du bloc Départ.
            this.salarieCourant.CodeMotifDepart = undefined;
            this.salarieCourant.CodeMotifRuptureContrat = undefined;
            this.dateNotificationRupture = undefined;
            this.salarieCourant.TransactionEnCours = undefined;
            this.dateDernierJourTravailleEtPaye = undefined;
            this.dateEntretienPrealable = undefined;
            this.dateSignatureRuptConv = undefined;
        }

        this.modify();
    }

    public modifyClassification(): void {
        if (this.salarieCourant != undefined) {
            if (this.salarieCourant.CodeClassification == "C01" ||
                this.salarieCourant.CodeClassification == "C02" ||
                this.salarieCourant.CodeClassification == "C03" ||
                this.salarieCourant.CodeClassification == "C04") {
                // Pour ces codes de classification, le code 'durée de contrat' passe automatiquement en Forfait Jour (code 10).
                this.salarieCourant.CodeDureeContrat = "10";
                if (this.salarieCourant.NbForfaitJours == undefined) {
                    this.salarieCourant.NbForfaitJours = this.nbForfaitJoursParDefaut;
                }
            } else if (this.salarieCourant.CodeDureeContrat == "10") {
                // Pour les autres codes de classification, le code 'durée de contrat' est placé au premier par défaut s'il était en Forfait Jour.
                this.salarieCourant.CodeDureeContrat = this.listeDureeContrats[0].Code;
            }
        }

        this.modifyPropertiesPrincipales();
    }

    public departIsSet(): boolean {
        return this.dateFinContrat != undefined && moment.utc(this.dateFinContrat).isValid();
    }

    public fetchData(): void {
        if (this.currentId < 1) {
            return;
        }
        this.dataReady = false;

        if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
            if (isNaN(Number(this.$route.query.idContrat))) {
                ServicesFactoryInstance.SalarieService.getSalarieQualification(this.currentId, this.setData, () => this.dataReady = true);
            } else {
                ServicesFactoryInstance.SalarieService.getSalarieQualificationForContrat(this.currentId, Number(this.$route.query.idContrat), this.setData, () => this.dataReady = true);
            }
        } else {
            this.dataReady = true;
            this.isModified = this.salarieCharges[this.currentId].isModified;
            this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
            this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
            this.proprietePrincipalesChanged = this.salarieCharges[this.currentId].proprietePrincipalesChanged;

            // Qualification
            this.dateEntree = this.salarieCharges[this.currentId].dateEntree;
            this.dateDebut = this.salarieCharges[this.currentId].dateDebut;
            this.dateFinPrevisionnelle = this.salarieCharges[this.currentId].dateFinPrevisionnelle;
            this.dateFinContrat = this.salarieCharges[this.currentId].dateFinContrat;
            this.dateDepartSalarie = this.salarieCharges[this.currentId].dateDepartSalarie;
            this.dateFinPeriodeEssai = this.salarieCharges[this.currentId].dateFinPeriodeEssai;
            this.dureeContrat = this.salarieCharges[this.currentId].dureeContrat;
            this.qualificationOrigine = this.salarieCharges[this.currentId].qualificationOrigine;
            this.classificationOrigine = this.salarieCharges[this.currentId].classificationOrigine;

            // Départ
            this.dateNotificationRupture = this.salarieCharges[this.currentId].dateNotificationRupture;
            this.dateSignatureRuptConv = this.salarieCharges[this.currentId].dateSignatureRuptConv;
            this.dateEntretienPrealable = this.salarieCharges[this.currentId].dateEntretienPrealable;
            this.dateDernierJourTravailleEtPaye = this.salarieCharges[this.currentId].dateDernierJourTravailleEtPaye;
            this.dateDebutPreavis = this.salarieCharges[this.currentId].dateDebutPreavis;
            this.dateFinPreavis = this.salarieCharges[this.currentId].dateFinPreavis;

            this.setListeQualificationsFiltrees();
            this.setListeClassificationsFiltrees();
            this.setListeMotifsDepartFiltree();
        }
    }

    public setData(data: SalarieContratDto): void {
        if (data.IdSalarie != this.currentId) {
            return;
        }

        this.salarieCourant = data;
        if (this.salarieCourant && this.salarieCourant.IdContrat == 0) {
            this.isModified = true;
            this.salarieCourant.RubriqueContrats = [];
        }

        if (this.salarieCourant != undefined) {
            this.proprietePrincipalesChanged = false;

            // Qualification
            this.dateEntree = this.salarieCourant.DateEntree == undefined ? undefined : moment.utc(this.salarieCourant.DateEntree).format("YYYY-MM-DD");
            this.dateDebut = this.salarieCourant.DateDebut == undefined ? undefined : moment.utc(this.salarieCourant.DateDebut).format("YYYY-MM-DD");
            this.dateFinPrevisionnelle = this.salarieCourant.DateFinPrevisionnelle == undefined ? undefined : moment.utc(this.salarieCourant.DateFinPrevisionnelle).format("YYYY-MM-DD");
            this.dateFinContrat = this.salarieCourant.DateFinContrat == undefined ? undefined : moment.utc(this.salarieCourant.DateFinContrat).format("YYYY-MM-DD");
            this.dateDepartSalarie = this.salarieCourant.DateDepartSalarie == undefined ? undefined : moment.utc(this.salarieCourant.DateDepartSalarie).format("YYYY-MM-DD");
            this.dateFinPeriodeEssai = this.salarieCourant.DateFinPeriodeEssai == undefined ? undefined : moment.utc(this.salarieCourant.DateFinPeriodeEssai).format("YYYY-MM-DD");
            this.dureeContrat = this.salarieCourant.DureeContrat;

            const codeQualification = this.salarieCourant.CodeQualification;
            this.qualificationOrigine = codeQualification && this.listeQualifications
                ? this.listeQualifications.filter(q => q.Code === codeQualification)[0]
                : undefined;

            const codeClassification = this.salarieCourant.CodeClassification;
            this.classificationOrigine = codeClassification && this.listeClassifications
                ? this.listeClassifications.filter(c => c.Code === codeClassification)[0]
                : undefined;

            // Départ
            this.dateNotificationRupture = this.salarieCourant.DateNotificationRupture == undefined ? undefined : moment.utc(this.salarieCourant.DateNotificationRupture).format("YYYY-MM-DD");
            this.dateSignatureRuptConv = this.salarieCourant.DateSignatureRuptConv == undefined ? undefined : moment.utc(this.salarieCourant.DateSignatureRuptConv).format("YYYY-MM-DD");
            this.dateEntretienPrealable = this.salarieCourant.DateEntretienPrealable == undefined ? undefined : moment.utc(this.salarieCourant.DateEntretienPrealable).format("YYYY-MM-DD");
            this.dateDernierJourTravailleEtPaye = this.salarieCourant.DateDernierJourTravailleEtPaye == undefined ? undefined : moment.utc(this.salarieCourant.DateDernierJourTravailleEtPaye).format("YYYY-MM-DD");
            this.dateDebutPreavis = this.salarieCourant.DateDebutPreavis == undefined ? undefined : moment.utc(this.salarieCourant.DateDebutPreavis).format("YYYY-MM-DD");
            this.dateFinPreavis = this.salarieCourant.DateFinPreavis == undefined ? undefined : moment.utc(this.salarieCourant.DateFinPreavis).format("YYYY-MM-DD");
            this.dateEntretienPrealable = this.salarieCourant.DateEntretienPrealable == undefined ? undefined : moment.utc(this.salarieCourant.DateEntretienPrealable).format("YYYY-MM-DD");

            this.setListeQualificationsFiltrees();
            this.setListeClassificationsFiltrees();
            this.setListeMotifsDepartFiltree();
            this.setDateNotificationRuptureRequired();
        }
        this.dataReady = true;

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
    }

    public limitDigitNumber($event: any, previousValue: any): void {
        // restrict to 2 decimal places
        if (previousValue != null && previousValue.indexOf(".") > -1 && (previousValue.split(".")[1].length > 1)) {
            $event.preventDefault();
        }
    }

    public nouveauContrat(): void {
        this.dataReady = false;
        NotificationServiceInstance.SendSuccess("Création d'un nouveau contrat");
        ServicesFactoryInstance.SalarieService.CreateContrat(this.currentId, data => {
            this.setData(data);
            this.$emit("isModified", true);
            this.isModified = true;
            NotificationServiceInstance.SendSuccess("La création du contrat s'est correctement déroulée !");
        }, () => {
            this.dataReady = true;
        });
    }

    public enregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }

        if (!this.controleValidationMetier()) {
            return false;
        }

        if (this.proprietePrincipalesChanged) {
            const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
                {
                    message: "Vous avez effectué une modification du contrat impliquant un changement dans la DSN. Souhaitez-vous vraiment valider votre modification ?",
                    callBackYes: () => {
                        this.proprietePrincipalesChanged = false;
                        this.enregistrer();
                    },
                    callBackNo: () => { },
                    canClose: true,
                    showDialog: true,
                    title: "Modification du contrat"
                });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);

            return false;
        }

        if (this.salarieCourant != undefined) {
            // Qualification
            if (this.dateEntree != undefined) {
                this.salarieCourant.DateEntree = moment.utc(this.dateEntree).toDate();
            }
            if (this.dateDebut != undefined) {
                this.salarieCourant.DateDebut = moment.utc(this.dateDebut).toDate();
            }
            if (this.dateFinPrevisionnelle != undefined) {
                this.salarieCourant.DateFinPrevisionnelle = moment.utc(this.dateFinPrevisionnelle).toDate();
            }
            if (this.dateFinContrat != undefined) {
                this.salarieCourant.DateFinContrat = moment.utc(this.dateFinContrat).toDate();
            }
            if (this.dateDepartSalarie != undefined) {
                this.salarieCourant.DateDepartSalarie = moment.utc(this.dateDepartSalarie).toDate();
            }
            if (this.dateFinPeriodeEssai != undefined) {
                this.salarieCourant.DateFinPeriodeEssai = moment.utc(this.dateFinPeriodeEssai).toDate();
            }
            if (this.dateFinPrevisionnelle != undefined) {
                this.salarieCourant.DateFinPrevisionnelle = moment.utc(this.dateFinPrevisionnelle).toDate();
            }
            if (this.dateDepartSalarie != undefined) {
                this.salarieCourant.DateDepartSalarie = moment.utc(this.dateDepartSalarie).toDate();
            }
            if (this.dateFinContrat != undefined) {
                this.salarieCourant.DateFinContrat = moment.utc(this.dateFinContrat).toDate();
            }

            // Départ
            this.salarieCourant.DateNotificationRupture = this.dateNotificationRupture != undefined ? moment.utc(this.dateNotificationRupture).toDate() : undefined;
            this.salarieCourant.DateSignatureRuptConv = this.dateSignatureRuptConv != undefined ? moment.utc(this.dateSignatureRuptConv).toDate() : undefined;
            this.salarieCourant.DateEntretienPrealable = this.dateEntretienPrealable != undefined ? moment.utc(this.dateEntretienPrealable).toDate() : undefined;
            this.salarieCourant.DateDernierJourTravailleEtPaye = this.dateDernierJourTravailleEtPaye != undefined ? moment.utc(this.dateDernierJourTravailleEtPaye).toDate() : undefined;
            this.salarieCourant.DateDebutPreavis = this.dateDebutPreavis != undefined ? moment.utc(this.dateDebutPreavis).toDate() : undefined;
            this.salarieCourant.DateFinPreavis = this.dateFinPreavis != undefined ? moment.utc(this.dateFinPreavis).toDate() : undefined;
        }

        this.$children.forEach(c => {
            const child: any = c;
            if (child.updateSalarie != undefined) {
                child.updateSalarie();
            }
        });

        this.dataReady = false;
        ServicesFactoryInstance.SalarieService.updateSalarieQualifications(this.salarieCourant, data => {
            this.setData(data);

            if (data.IdContrat != undefined) {
                this.handleFutureAbsences(data.IdContrat);
            }

            this.$emit("isModified", false);
            this.$emit("qualificationUpdated");
            this.isModified = false;
            NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
        }, () => {
            this.dataReady = true;
        });

        return false;
    }

    private controleValidationMetier(): boolean {
        const errorMessage: string[] = [];

        if (this.isContratActif()) {
            const qualification = this.listeQualifications.filter(q => q.Code == this.salarieCourant?.CodeQualification)[0];
            const classification = this.listeClassifications.filter(q => q.Code == this.salarieCourant?.CodeClassification)[0];
            if (qualification && qualification.EstArchive) {
                errorMessage.push("Le code classification ne doit pas être obsolète.");
            }
            if (classification && classification.EstArchive) {
                errorMessage.push("La classification ne doit pas être obsolète.");
            }
        }

        if (errorMessage.length > 0) {
            for (let i = 0; i < errorMessage.length; i++) {
                NotificationServiceInstance.SendFailed(errorMessage[i]);
            }

            return false;
        }

        return true;
    }

    private isContratActif(): boolean {
        if (!this.salarieCourant?.DateFinContrat) {
            // Pas de date de fin --> Contrat actif.
            return true;
        }

        if (!ParametresInstance?.societeCourante?.DernierExercice) {
            // Pas d'exercice ouvert encore --> On part du principe qu'on ne peut pas effectuer le test.
            return false;
        }

        let dateDernierExercice: Date | undefined;
        if (ParametresInstance?.societeCourante?.DernierExercice instanceof Date) {
            // Si la date du dernier exercice est correctement instanciée comme une date, on la récupère en tant que date.
            dateDernierExercice = ParametresInstance?.societeCourante?.DernierExercice;
        } else {
            // Sinon, on tente d'instancier une date à partir de la chaine de caractère de la variable.
            dateDernierExercice = new Date(ParametresInstance?.societeCourante?.DernierExercice);
        }
        if (!dateDernierExercice) {
            // Si on a pas réussi à récupérer la date de dernier exercice sous forme de date, on ne va pas plus loin.
            return false;
        }

        // On prend le premier jour de la date d'exercice.
        const premierJourExercice = new Date(dateDernierExercice.getFullYear(), dateDernierExercice.getMonth(), 1);

        return premierJourExercice < this.salarieCourant.DateFinContrat;
    }

    private handleFutureAbsences(idNouveauContrat: number) {
        if (this.salarieCourant == undefined) {
            return;
        }

        if (this.salarieCourant.IdContrat == 0) {
            this.openModalTransfertAbsences(idNouveauContrat);
        } else {
            this.openModalAbsencesFuturesFinDeContrat();
        }
    }

    private openModalTransfertAbsences(idNouveauContrat: number) {
        if (this.salarieCourant == undefined) {
            return;
        }

        ServicesFactoryInstance.SalarieService.getMostRecentContratTermine(this.salarieCourant.IdSalarie, mostRecentContrat => {
            if (mostRecentContrat.IdContrat == undefined || mostRecentContrat.DateFinContrat == undefined) {
                return;
            }

            const demandeRecuperation: DemandeRecuperationAbsencesFuturesDto = {
                IdContrat: mostRecentContrat.IdContrat,
                DateMax: mostRecentContrat.DateFinContrat
            };

            ServicesFactoryInstance.AbsencesService.getAbsencesFuturesByContrat(demandeRecuperation, data => {
                const demandeTransfert: DemandeTransfertAbsenceDto = {
                    IdAncienContrat: mostRecentContrat.IdContrat!,
                    IdNouveauContrat: idNouveauContrat
                };

                this.modalTransfertAbsencesFutures = this.$refs.modalTransfertAbsencesFutures as ModalTransfertAbsencesFutures;
                if (this.modalTransfertAbsencesFutures != undefined && data != undefined && data.length > 0) {
                    this.modalTransfertAbsencesFutures.init(data, demandeTransfert);
                }
            });
        });
    }

    private openModalAbsencesFuturesFinDeContrat(): void {
        if (this.salarieCourant == undefined || this.salarieCourant.IdContrat == undefined || this.salarieCourant.DateFinContrat == undefined) {
            return;
        }

        const demandeRecuperation: DemandeRecuperationAbsencesFuturesDto = {
            IdContrat: this.salarieCourant.IdContrat,
            DateMax: this.salarieCourant?.DateFinContrat
        };

        ServicesFactoryInstance.AbsencesService.getAbsencesFuturesByContrat(demandeRecuperation, data => {
            this.modalAbsencesFuturesFinDeContrat = this.$refs.modalAbsencesFuturesFinDeContrat as ModalAbsencesFuturesFinDeContrat;
            if (this.modalAbsencesFuturesFinDeContrat != undefined && data.length > 0) {
                this.modalAbsencesFuturesFinDeContrat.init(data);
            }
        });
    }

    public faireSortie(): void {
        if (this.isModified) {
            NotificationServiceInstance.SendFailed("Vous devez enregistrer vos modifications en cours avant d'effectuer la sortie du salarié.");

            return;
        }

        if (ParametresInstance.societeCourante == undefined) {
            NotificationServiceInstance.SendFailed("Vous ne pouvez pas effectuer la sortie du salarié car vous n'avez pas sélectionné de société.");

            return;
        }

        if (ParametresInstance.societeCourante.PeriodeActive == undefined) {
            NotificationServiceInstance.SendFailed("Vous ne pouvez pas effectuer la sortie du salarié car aucun exercice n'est en cours.");

            return;
        }

        if (this.salarieCourant && this.salarieCourant.IdContrat) {
            NotificationServiceInstance.SendSuccess("Lancement des éditions de sortie du salarié.");
            ServicesFactoryInstance.SalarieService.FaireSortie(this.salarieCourant.IdContrat, () => {
                this.$emit("listeDocumentsModifiee");
                NotificationServiceInstance.SendSuccess("La sortie a été effectuée, vous trouverez les documents dans la ged du salarié.");
            }, () => {
                this.dataReady = true;
            });
        }
    }

    public annuler(): void {
        if (this.salarieCharges[this.currentId] != undefined) {
            this.salarieCharges[this.currentId].isModified = false;
        }
        this.fetchData();
        this.isModified = false;
        this.$emit("isModified", false);
    }

    public modifyDureeContrat(): void {
        this.$children.forEach(c => {
            const child: any = c;
            if (child.modifyDureeContrat != undefined) {
                child.modifyDureeContrat(this.dureeContrat);
            }
        });

        this.modify();
    }

    public modifyMotifDepart(): void {
        if (this.salarieCourant) {
            if (this.salarieCourant.CodeMotifDepart === "010" && this.listeMotifRuptures.filter(m => m.Code === "59").length === 1) {
                this.salarieCourant.CodeMotifRuptureContrat = "59";
            } else if (this.salarieCourant.CodeMotifDepart === "008" && this.listeMotifRuptures.filter(m => m.Code === "31").length === 1) {
                this.salarieCourant.CodeMotifRuptureContrat = "31";
            } else if (this.salarieCourant.CodeMotifDepart === "138" && this.listeMotifRuptures.filter(m => m.Code === "43").length === 1) {
                this.salarieCourant.CodeMotifRuptureContrat = "43";
            } else {
                return;
            }

            this.setDateNotificationRuptureRequired();
            this.modify();
        }
    }

    // Permet d'effectuer des actions quand le type de préavis est modifié.
    public modifyTypePreavis(): void {
        if (this.salarieCourant && this.salarieCourant.CodeTypePreavis == "PASPR") {
            this.dateDebutPreavis = undefined;
            this.dateFinPreavis = undefined;
        }

        this.modify();
    }

    public modify(): void {
        this.$emit("isModified", true);
        this.isModified = false;
        this.isModified = true;
    }

    public modifyMotifRuptureContrat(): void {
        this.setDateNotificationRuptureRequired();

        this.modify();
    }

    public setDateNotificationRuptureRequired(): void {
        this.isDateNotificationRuptureRequired = (ParametresInstance.listeMotifsPourDateNotificationRuptureObligatoire.filter(c => c === this.salarieCourant?.CodeMotifRuptureContrat).length > 0);
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/qualifications/qualificationsSalarie.ts